import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=80462dfa&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80462dfa')) {
      api.createRecord('80462dfa', component.options)
    } else {
      api.reload('80462dfa', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=80462dfa&", function () {
      api.rerender('80462dfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2U2N4Db8m2KFn/JS/comp/openstreetmap.vue"
export default component.exports